import { Link } from 'react-router-dom';
import { KeenIcon } from '@/components';
import { SECURITY_SWITCHES } from './securitySwitches';

/**
 * Security & Data Controls card (OL-152): the firm-wide safeguards, each a
 * switch. Like the AI Features card, a save resends the firm's required core
 * fields unchanged alongside the flag, because the settings endpoint needs them.
 */
const AdvancedSettingsSecurity = ({ data, onConfirm, loadData, loadDataSave }) => {
  const busy = loadData || loadDataSave || !data;

  const handleToggle = (key) => {
    if (busy) return;

    const formData = new FormData();
    formData.append('legal_business_name', data.legal_business_name ?? '');
    formData.append('country', data.country ?? '');
    formData.append('date_format', data.date_format ?? '');
    formData.append('time_format', data.time_format ?? '');
    formData.append(key, data[key] === true ? '0' : '1');
    formData.append('_method', 'PUT');
    onConfirm(formData);
  };

  return (
    <div className="card">
      <div className="card-header" id="advanced_settings_security">
        <h3 className="card-title">Security &amp; Data Controls</h3>
        <div className="flex gap-2">
          <Link to="/account/audit-log" className="btn btn-sm btn-light">
            <KeenIcon icon="document" /> Audit Log
          </Link>
          <Link to="/account/export-requests" className="btn btn-sm btn-light">
            <KeenIcon icon="file-down" /> Export Requests
          </Link>
        </div>
      </div>
      <div className="card-body lg:py-7.5 flex flex-col gap-6">
        {SECURITY_SWITCHES.map(({ key, icon, title, description }) => (
          <div key={key} className="flex items-center justify-between gap-4">
            <div className="flex items-start gap-3">
              <KeenIcon icon={icon} className="text-lg text-primary mt-0.5" />
              <div className="flex flex-col gap-1">
                <span className="text-sm font-medium text-gray-900">{title}</span>
                <span className="text-xs text-gray-500 max-w-[560px]">{description}</span>
              </div>
            </div>

            <label className="switch shrink-0">
              <input
                type="checkbox"
                checked={data?.[key] === true}
                onChange={() => handleToggle(key)}
                disabled={busy}
                aria-label={title}
              />
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export { AdvancedSettingsSecurity };
